<template>
  <BRow>
    <BCol cols="12">
      <div class="mb-2 d-flex align-items-center justify-content-between">
        <h2>درس های این زبان</h2>
        <BButton
          @click="changeLessonsPriority"
          :disabled="isReOrderButtonDisabled"
          variant="success"
        >
          ثبت اولویت های جدید
        </BButton>
      </div>
      <BTableSimple bordered striped class="table-item">
        <BThead>
          <BTh v-for="(item, index) in tableColumns" :key="index">
            {{ item.label }}
          </BTh>
        </BThead>
        <draggable
          :scroll-sensitivity="550"
          handle=".handler"
          :force-fallback="true"
          @end="setNewOrder"
          tag="tbody"
          role="rowgroup"
        >
          <BTr
            v-for="item in alreadyCreatedLessons"
            :key="item.id"
            class="item-row"
          >
            <BTd>
              <BButton
                variant="transparent"
                class="d-flex align-items-center justify-content-center w-100 handler"
              >
                <FeatherIcon icon="MenuIcon" size="20" />
              </BButton>
            </BTd>
            <BTd>{{ item.priority }}</BTd>
            <BTd style="font-family: sans-serif !important;">{{ item.title }}</BTd>
            <BTd>
              <div
                class="w-100 d-flex align-items-center justify-content-center"
              >
                <BBadge :variant="item.isRequired ? 'danger' : 'success'">
                  {{ item.isRequired ? "بله" : "خیر" }}
                </BBadge>
              </div>
            </BTd>
            <BTd>
              <div
                class="w-100 d-flex align-items-center justify-content-center"
              >
                <BBadge :variant="item.justBasic ? 'success' : 'danger'">
                  {{ item.justBasic ? "بله" : "خیر" }}
                </BBadge>
              </div>
            </BTd>
            <BTd>
              {{ Intl.NumberFormat("en-US").format(item.price) }}
              تومان
            </BTd>
            <BTd>
              <b-link :to="`/independent-lessons/${item.id}`">
                <feather-icon class="text-primary" icon="EditIcon" size="20" />
              </b-link>
            </BTd>
            <BTd>
              <BButton variant="transparent" @click="setTempLesson(item)">
                <FeatherIcon icon="Trash2Icon" size="20" class="text-danger" />
              </BButton>
            </BTd>
          </BTr>
        </draggable>
      </BTableSimple>
    </BCol>
    <BModal
      title="حذف درس"
      id="independent-lesson-delete-modal"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteAnIndependentLesson"
    >
      <BContainer>
        <span v-if="tempLesson">
          آیا از حذف کردن درس
          <b>
            {{ tempLesson.title }}
          </b>

          اطمینان دارید؟
        </span>
      </BContainer>
    </BModal>
  </BRow>
</template>
<script>
export default {
  mounted() {
    this.getAllIndependentLessons();
  },
  data() {
    return {
      tempLesson: null,
      alreadyCreatedLessons: null,
      isReOrderButtonDisabled: true,
      independentLessonFilters: {
        languageId: this.$route.params.id,
        title: null,
        pageNumber: 1,
        count: 200,
      },
      tableColumns: [
        {
          key: "handler",
          label: "تغییر اولویت",
        },
        {
          key: "priority",
          label: "اولویت",
        },
        {
          key: "title",
          label: "نام درس",
        },
        {
          key: "isRequired",
          label: "اجباری است؟",
        },
        {
          key: "justBasic",
          label: "ثبت در نقشه راه",
        },
        {
          key: "price",
          label: "قیمت درس",
        },
        {
          key: "Edit",
          label: "ویرایش",
        },
        {
          key: "Delete",
          label: "حذف",
        },
      ],
    };
  },
  methods: {
    setNewOrder(event) {
      // Check if any index has changed
      if (event.oldIndex != event.newIndex) {
        this.arrayMove(
          this.alreadyCreatedLessons,
          event.oldIndex,
          event.newIndex
        );
      }
    },
    arrayMove(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      if (this.isReOrderButtonDisabled) {
        this.isReOrderButtonDisabled = false;
      }
    },

    createLessonPriorityPayload() {
      let lessonPriority = [];
      this.alreadyCreatedLessons.forEach((item, index) => {
        lessonPriority.push({
          id: item.id,
          priority: index + 1,
        });
      });
      return lessonPriority;
    },

    async changeLessonsPriority() {
      try {
        this.isLoading = true;
        let _this = this;
        let changeLessonsPriority = new ChangeLessonsPriority(_this);
        changeLessonsPriority.setRequestParamDataObj({
          lessonPriority: _this.createLessonPriorityPayload(),
        });
        await changeLessonsPriority.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تغییر کرد!",
                icon: "CheckIcon",
                variant: "success",
                text: "اولویت درس ها با موفقیت تغییر کرد.",
              },
            });
            _this.isReOrderButtonDisabled = true;
            _this.getAllIndependentLessons();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی رخ داد!",
                icon: "Trash2Icon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setTempLesson(lesson) {
      this.tempLesson = JSON.parse(JSON.stringify(lesson));
      this.$bvModal.show("independent-lesson-delete-modal");
    },
    async deleteAnIndependentLesson() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteAnIndependentLesson = new DeleteAnIndependentLesson(_this);
        deleteAnIndependentLesson.setRequestParam({
          id: _this.tempLesson.id,
        });
        await deleteAnIndependentLesson.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "موفقیت آمیز بود",
                icon: "Trash2Icon",
                variant: "success",
                text: "کلاس با موفقیت حذف شد.",
              },
            });
            _this.getAllIndependentLessons();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllIndependentLessons() {
      try {
        this.isLoading = true;
        let _this = this;
        let getIndependentLessonsList = new GetIndependentLessonsList(_this);
        getIndependentLessonsList.setRequestParamDataObj(
          _this.independentLessonFilters
        );
        await getIndependentLessonsList.fetch((res) => {
          _this.alreadyCreatedLessons = res.data;
          _this.alreadyCreatedLessons.sort((a, b) => a.priority - b.priority);
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BLink,
    BBadge,
    BOverlay,
    BFormFile,
    BFormTextarea,
    BModal,
    BContainer,
    BTableSimple,
    BTr,
    BTd,
    BTh,
    BThead,
    Draggable,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
  BLink,
  BBadge,
  BOverlay,
  BFormFile,
  BFormTextarea,
  BModal,
  BContainer,
  BTableSimple,
  BTr,
  BTd,
  BTh,
  BThead,
} from "bootstrap-vue";
import Draggable from "vuedraggable";
import {
  GetIndependentLessonsList,
  DeleteAnIndependentLesson,
} from "@/libs/Api/IndependentLesson";
import { ChangeLessonsPriority } from "@/libs/Api/Lesson";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
